import { FavouriteOffIcon } from "@common/components/icons";

type Props = {
  index: number;
};

const EmptyVehicleCard = ({ index }: Props) => {
  return (
    <div className="relative bg-primary-light-100 rounded-lg shadow-elevation-00 overflow-hidden aspect-none pb-4">
      <span className="absolute top-3 right-3 w-5 h-5 text-white text-center rounded-full bg-gray-300">
        {index}
      </span>
      <div className="h-[25rem]">
        <FavouriteOffIcon className="relative text-[5rem] text-gray-200 m-auto top-[40%]" />
      </div>
    </div>
  );
};

export default EmptyVehicleCard;
